export default __webpack_public_path__ + "static/media/grey-co2-clouds.60bd2d32.png";